// Confluence gates
// https://switcheroo.atlassian.com/ui/gates/21254a40-1d57-4de4-9980-f9e2f7dbcb17/key/rovo-ext_left_nav_cta_filter
export const ROVO_EXTENSION_LEFT_NAV_CTA_FILTER_GATE = 'rovo-ext_left_nav_cta_filter';
// https://switcheroo.atlassian.com/ui/gates/4bb14a49-572d-4f41-99b8-3d8ca5260adc/key/rovo-ext_left_nav_rovo_extension_cta
export const ROVO_EXTENSION_LEFT_NAV_CTA_EXPERIMENT = 'rovo-ext_left_nav_rovo_extension_cta';

// Jira gates
// https://switcheroo.atlassian.com/ui/gates/c63b19db-1d0d-4610-a2d9-0fe784a3beeb/key/left_nav_rovo_extension_jira_cta_rovo_extension
export const ROVO_EXTENSION_JIRA_LEFT_NAV_CTA_EXPERIMENT =
	'left_nav_rovo_extension_jira_cta_rovo_extension';
// https://switcheroo.atlassian.com/ui/gates/f291157f-5e71-40ec-a70d-4a08112fb99c/key/left_nav_jira_cta_rovo_extension_lifecycle
export const ROVO_EXTENSION_JIRA_LEFT_NAV_CTA_LIFECYCLE =
	'left_nav_jira_cta_rovo_extension_lifecycle';

// Jira side-nav experiment variants
export enum JiraSideNavVariant {
	CONTROL = 'control',
	EXISTING = 'existing',
	NEW = 'new',
	ROVO = 'newRovo',
}
export type VariantType = JiraSideNavVariant | null;
export const DEFAULT_VARIANT: JiraSideNavVariant.CONTROL = JiraSideNavVariant.CONTROL;
